import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { EMode } from '../Enums/EMode.enum';

export class FspProviderTestResult<T extends EMode = EMode.entity> {
  /** Alias: fspId */
  fspId?: number;
  /** Alias: isSuccess */
  isSuccess?: boolean;
  /** Alias: errorMessage */
  errorMessage?: string;
  /** Alias: testTime */
  testTime?: number;

  __typename?: string;
}

const fields: FieldDefinitions<FspProviderTestResult> = {
  fspId: {
    alias: 'fspId',
  },
  isSuccess: {
    alias: 'isSuccess',
  },
  errorMessage: {
    alias: 'errorMessage',
  },
  testTime: {
    alias: 'testTime',
  },
  __typename: {
    alias: '__typename',
  },
};

export const fspProviderTestResultEntityDefinition: EntitiyDefinition<FspProviderTestResult> =
  {
    local: {},
    remote: {
      queryName: '',
      fragmentName: 'FspProviderTestResult',
      withPaginationWrapper: false,
    },
    fieldDefinitions: fields,
  };
